
import { ActivimeterCalibrationDto, CreateActivimeterCalibrationDto, UpdateActivimeterCalibrationDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { activimeterCalibrationService, ActivimeterCalibrationsFilters } from '@services/activimeterCalibrationService'

const { reducer, actions, thunks } = baseCrudReducer<
  ActivimeterCalibrationDto,
  CreateActivimeterCalibrationDto,
  UpdateActivimeterCalibrationDto,
  ActivimeterCalibrationsFilters
>('activimeterCalibration', activimeterCalibrationService)

export default reducer

export const { setFilters: setActivimeterCalibrationFilters } = actions

export const {
  getAll: getActivimeterCalibrations,
  create: createActivimeterCalibration,
  update: updateActivimeterCalibration,
  remove: removeActivimeterCalibration,
} = thunks
